import { apiFetch } from "@/lib/api"

export const getBillingSubscription = () => apiFetch("/api/v1/billing/subscription")

export const getBillingPlans = () => apiFetch("/api/v1/billing/plans")

export const createCheckoutSession = (tier, { csrfToken } = {}) =>
  apiFetch("/api/v1/billing/checkout-sessions", {
    method: "POST",
    body: { tier },
    csrfToken,
  })

export const createPortalSession = ({ csrfToken } = {}) =>
  apiFetch("/api/v1/billing/portal-sessions", {
    method: "POST",
    csrfToken,
  })

export const createUpgradeSession = (tier, { csrfToken, attemptId } = {}) =>
  apiFetch("/api/v1/billing/upgrade-sessions", {
    method: "POST",
    body: { tier, attempt_id: attemptId },
    csrfToken,
  })
